<template>
    <div class="ubicacion">
        <div class="form-group">
            <label class="col-sm-2 control-label subtitle"><em>Ubicación</em></label>
        </div>

        <!-- Comuna -->
        <div class="form-group" :class="{ 'has-error': localErrors['location_id'] }">
            <label for="location_id" class="col-sm-2 control-label">Comuna</label>
            <div class="col-sm-10">
                <city-select id="location_id" v-model="localValue.location_id" ref="comuna"></city-select>
                <div class="help-block" v-for="e in localErrors['location_id']" :key="e">{{ e }}</div>
            </div>
        </div>

        <!-- Dirección -->
        <div class="form-group" :class="{ 'has-error': localErrors['address'] }">
            <label for="address" class="col-sm-2 control-label">Dirección</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" id="address" v-model="localValue.address">
                <div class="help-block" v-for="e in localErrors['address']" :key="e">{{ e }}</div>
            </div>
            <div class="col-sm-2">
                <label class="btn btn-primary" @click="buscar()" :disabled="disabled">Buscar</label>
                <a class="btn btn-default" :href="manualUrl" data-toggle="tooltip" target="_blank" data-placement="top"
                    title="Consultar Manual de Uso.">
                    <span class="glyphicon glyphicon-question-sign" aria-hidden="true"></span>
                </a>
            </div>
        </div>

        <!-- Selector de tipo de mapa -->
        <div class="form-group">
            <label class="col-sm-2 control-label">Tipo de Ubicación</label>
            <div class="col-sm-10">
                <select class="form-control" id="map_type" v-model="localValue.map_type">
                    <option value="coordinates">Map Ltd y Lng</option>
                    <option value="url">Map URL</option>
                </select>
            </div>
        </div>

        <template>
            <!-- URL de Google Maps -->
            <div class="form-group" v-if="localValue.map_type === 'url'"
                :class="{ 'has-error': localErrors['map_url'] }">
                <label for="map_url" class="col-sm-2 control-label">URL de Google Maps</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" id="map_url" v-model="localValue.map_url">
                    <div class="help-block" v-for="e in localErrors['map_url']" :key="e">{{ e }}</div>
                </div>
            </div>
            <!-- Mapa con Marcador -->
            <div class="form-group" :class="{ 'has-error': errors['map_marker'] }">
                <label for="map_marker" class="col-sm-2 control-label">Marcador</label>
                <div class="col-sm-10">
                    <div id="map_marker"></div>
                    <div class="help-block" v-for="e in errors['map_marker']" :key="e">{{ e }}</div>
                    <small class="text-muted">Puedes arrastrar el marcador para ajustar la ubicación exacta</small>
                </div>
            </div>

            <!-- Coordenadas -->
            <div class="form-group" :class="{ 'has-error': errors['lat'] }">
                <label for="lat" class="col-sm-2 control-label">Latitud</label>
                <div class="col-sm-10">
                    <input type="number" step="0.000001" class="form-control" id="lat" v-model.number="localValue.lat">
                    <div class="help-block" v-for="e in errors['lat']" :key="e">{{ e }}</div>
                </div>
            </div>

            <div class="form-group" :class="{ 'has-error': errors['lng'] }">
                <label for="lng" class="col-sm-2 control-label">Longitud</label>
                <div class="col-sm-10">
                    <input type="number" step="0.000001" class="form-control" id="lng" v-model.number="localValue.lng">
                    <div class="help-block" v-for="e in errors['lng']" :key="e">{{ e }}</div>
                </div>
            </div>
        </template>

        <!-- Observaciones de Ubicación -->
        <div class="form-group" :class="{ 'has-error': errors['location_observations'] }">
            <label for="location_observations" class="col-sm-2 control-label">Observaciones Ubicación</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="location_observations" rows="8" maxlength="140"
                    v-model="localValue.location_observations"></textarea>
                <small class="text-muted">{{ (localValue.location_observations || '').length }}/140 caracteres</small>
                <div class="help-block" v-for="e in errors['location_observations']" :key="e">{{ e }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import CitySelect from '../CitySelect.vue';

export default {
    name: 'LocationSection',

    components: {
        CitySelect
    },

    props: {
        value: {
            type: Object,
            required: true
        },
        errors: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            map: null,
            markers: {},
            OfficeIcon: null,
            disabled: false,
            manualUrl: `${baseUrl}/manual-backend/administracion_general/#213-oficinas`,
            localValue: {
                map_type: 'coordinates',
                location_id: null,
                address: null,
                lat: null,
                lng: null,
                map_url: null,
                location_observations: '',
                ...this.value
            },
            localErrors: {},
        }
    },

    watch: {
        localValue: {
            deep: true,
            handler(newValue) {
                this.$emit('input', newValue);
            }
        },
        // Agregar nuevos watchers para limpiar errores
        'localValue.location_id'(newValue) {
            if (newValue) {
                this.$delete(this.localErrors, 'location_id');
            }
        },
        'localValue.address': {
            handler(newValue) {
                if (newValue?.trim()) {
                    // Primero validamos
                    const addressErrors = this.validateAddress(newValue);
                    if (addressErrors.length > 0) {
                        // Si hay errores, los establecemos
                        this.$set(this.localErrors, 'address', addressErrors);
                    } else {
                        // Solo si no hay errores de validación, limpiamos los errores
                        this.$delete(this.localErrors, 'address');
                    }
                } else {
                    // Si está vacío, limpiamos los errores de validación
                    this.$delete(this.localErrors, 'address');
                }
            },
            immediate: true
        },
        'localValue.map_url'(newValue) {
            if (newValue?.trim()) {
                this.$delete(this.localErrors, 'map_url');
            }
        },
        'localValue.lat'(newValue) {
            if (newValue && this.localValue.lng) {
                this.$delete(this.localErrors, 'map_marker');
            }
        },
        'localValue.lng'(newValue) {
            if (newValue && this.localValue.lat) {
                this.$delete(this.localErrors, 'map_marker');
            }
        },
        'localValue.location_observations'(newValue) {
            if (newValue && newValue.length > 140) {
                this.localValue.location_observations = newValue.substring(0, 140);
            }
        },
        // Agregar watcher para validación en tiempo real de la URL
        'localValue.map_url': {
            handler(newValue) {
                if (this.localValue.map_type === 'url' && newValue?.trim()) {
                    const urlErrors = this.validateMapUrl(newValue);
                    if (urlErrors.length > 0) {
                        this.$set(this.localErrors, 'map_url', urlErrors);
                    } else {
                        this.$delete(this.localErrors, 'map_url');
                    }
                } else {
                    this.$delete(this.localErrors, 'map_url');
                }
            }
        }
    },

    methods: {
        initializeMap() {
            const default_pos = {
                lat: this.localValue.lat || -33.437796,
                lng: this.localValue.lng || -70.650445
            };

            this.map = L.map('map_marker', { zoomControl: false })
                .setView([default_pos.lat, default_pos.lng], 16);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
                maxZoom: 18
            }).addTo(this.map);

            L.control.zoom({
                zoomInTitle: 'Acercar',
                zoomOutTitle: 'Alejar'
            }).addTo(this.map);

            this.OfficeIcon = L.Icon.Default.extend({
                options: {
                    iconUrl: 'images/red-marker.png',
                    iconRetinaUrl: 'images/red-marker-2x.png'
                }
            });

            const officeIcon = new this.OfficeIcon();

            this.markers['pin'] = L.marker(
                [default_pos.lat, default_pos.lng],
                {
                    icon: officeIcon,
                    draggable: true,
                    autoPan: true,
                    setView: true
                }
            ).addTo(this.map);

            this.markers['pin'].on("drag", (e) => {
                const position = e.target.getLatLng();
                this.localValue.lat = Number(position.lat.toFixed(6));
                this.localValue.lng = Number(position.lng.toFixed(6));
            });
        },

        scrollToError(elementId) {
            this.$nextTick(() => {
                const element = document.getElementById(elementId);
                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                }
            });
        },
        validate() {
            // Limpiar errores previos
            this.localErrors = {};
            let isValid = true;

            // Validar comuna (siempre requerida)
            if (!this.localValue.location_id) {
                this.localErrors.location_id = ['La comuna es obligatoria'];
                this.scrollToError('location_id');
                isValid = false;
            }

            // Validar dirección (solo que no esté vacía y caracteres básicos)
            if (!this.localValue.address?.trim()) {
                this.localErrors.address = ['La dirección es obligatoria'];
                if (isValid) {
                    this.scrollToError('address');
                }
                isValid = false;
            } else {
                const addressErrors = this.validateAddress(this.localValue.address);
                if (addressErrors.length > 0) {
                    this.localErrors.address = addressErrors;
                    if (isValid) {
                        this.scrollToError('address');
                    }
                    isValid = false;
                }
            }

            // Si los campos básicos no son válidos, retornar aquí
            if (!isValid) {
                return false;
            }

            // Validaciones específicas según el tipo de mapa
            if (this.localValue.map_type === 'coordinates') {
                // No validamos lat/lng si ya tenemos comuna y dirección
                return true;
            } else if (this.localValue.map_type === 'url') {
                if (!this.localValue.map_url?.trim()) {
                    this.localErrors.map_url = ['El campo URL de Google Maps es obligatorio'];
                    this.scrollToError('map_url');
                    return false;
                }
            }

            // Validar URL si el tipo de mapa es 'url'
            if (this.localValue.map_type === 'url') {
                if (!this.localValue.map_url?.trim()) {
                    this.localErrors.map_url = ['El campo URL de Google Maps es obligatorio'];
                    this.scrollToError('map_url');
                    return false;
                }

                const urlErrors = this.validateMapUrl(this.localValue.map_url);
                if (urlErrors.length > 0) {
                    this.localErrors.map_url = urlErrors;
                    this.scrollToError('map_url');
                    isValid = false;
                }
            }

            // Si llegamos aquí, todo está válido
            return true;
        },
        buscar() {
            // Limpiar errores previos
            this.localErrors = {};

            // Validar campos requeridos antes de buscar
            let hasErrors = false;

            if (!this.localValue.location_id) {
                this.localErrors.location_id = ['Debe seleccionar una comuna'];
                this.scrollToError('location_id');
                hasErrors = true;
            }

            if (!this.localValue.address?.trim()) {
                this.localErrors.address = ['Debe ingresar una dirección'];
                if (!hasErrors) {
                    this.scrollToError('address');
                }
                hasErrors = true;
            }

            if (hasErrors) {
                return;
            }

            this.disabled = true;
            const city = this.$refs.comuna.cities ?
                _.find(this.$refs.comuna.cities, { id: this.localValue.location_id }) : '';
            const address = this.localValue.address || '';
            const query = address + ', ' + (city ? city.name : '');

            if (city && city.name) {
                axios({
                    url: 'https://nominatim.openstreetmap.org/search?q=' +
                        encodeURIComponent(query + ', Chile') + '&format=json&limit=1',
                    method: 'GET',
                    headers: {
                        'Accept-Language': 'es'
                    }
                }).then((response) => {
                    const result = _.first(response.data);
                    if (result) {
                        // Actualizar marcador y mapa
                        if (this.markers['pin']) {
                            this.markers['pin'].setLatLng([
                                Number(result.lat),
                                Number(result.lon)
                            ]);

                            this.map.panTo([
                                Number(result.lat),
                                Number(result.lon)
                            ]);

                            this.map.setZoom(16);
                        }

                        // Actualizar valores en el modelo
                        this.localValue.lat = Number(Number(result.lat).toFixed(6));
                        this.localValue.lng = Number(Number(result.lon).toFixed(6));

                        // Limpiar cualquier error previo del marcador
                        this.$delete(this.localErrors, 'map_marker');
                    } else {
                        alert('No fue posible encontrar la dirección ingresada: ' + query);
                    }
                }).catch((error) => {
                    console.error('Error en la geolocalización:', error);
                    alert('No fue posible conectar al servicio de geolocalización.');
                }).finally(() => {
                    this.disabled = false;
                });
            } else {
                this.disabled = false;
            }
        },
        validateAddress(address) {
            if (!address?.trim()) return [];

            let errors = [];
            const consecutivePatterns = {
                '--': 'guiones',
                '**': 'asteriscos',
                '##': 'numerales',
                '&&': 'símbolos &',
                '//': 'barras diagonales',
                '..': 'puntos',
                ',,': 'comas',
                '\'\'': 'comillas simples',
                '""': 'comillas dobles'
            };

            for (const [pattern, name] of Object.entries(consecutivePatterns)) {
                if (address.includes(pattern)) {
                    errors.push(`No se permiten ${name} consecutivos`);
                }
            }

            const validCharsRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s\.,#'"°º\-/()&*]+$/;
            if (!validCharsRegex.test(address)) {
                errors.push('La dirección solo puede contener letras, números, espacios y caracteres especiales comunes (.,-,#,*,etc)');
            }

            return errors;
        },
        validateMapUrl(url) {
            if (!url) return [];

            const MAX_URL_LENGTH = 500; // Largo máximo

            if (url.length > MAX_URL_LENGTH) {
                return ['La URL es demasiado larga, debe ser menor a 500 caracteres'];
            }

            // Regex validación estricta de URL
            const urlRegex = /^https:\/\/(?!.*https:\/\/)(?!.*\/{2,})(?!.*\.{2,})[a-zA-Z0-9][a-zA-Z0-9-._]*\.[a-zA-Z]{2,}(?:\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

            if (!urlRegex.test(url)) {
                return ['Debe ingresar una URL válida con formato correcto'];
            }

            return [];
        },
    },

    mounted() {
        this.initializeMap();
    },

    beforeDestroy() {
        if (this.map) {
            this.map.remove();
        }
    }
}
</script>

<style lang="scss" scoped>
.ubicacion {
    background: #F7F7F7;
    border: 1px solid #F7F7F7;
    border-radius: 4px;
    display: block;
    padding-top: 14px;
    margin-bottom: 7px;
}

.subtitle {
    color: #757575;
}

#map_marker {
    height: 280px;
    margin-bottom: 15px;
}
</style>